import Model from "../../Model";

export interface TReport7Applicant {
  id: number;
  name: string;
  partyId: string;
  surname: string;
}

export interface IReport7Applicant extends TReport7Applicant {}

const Report7Applicant = Model(
  (model: TReport7Applicant): IReport7Applicant => {
    const _report7Applicant: TReport7Applicant = Object.assign({}, model);

    return {
      get id() {
        return _report7Applicant.id;
      },
      set id(value) {
        _report7Applicant.id = value;
      },
      get name() {
        return _report7Applicant.name;
      },
      set name(value) {
        _report7Applicant.name = value;
      },
      get partyId() {
        return _report7Applicant.partyId;
      },
      set partyId(value) {
        _report7Applicant.partyId = value;
      },
      get surname() {
        return _report7Applicant.surname;
      },
      set surname(value) {
        _report7Applicant.surname = value;
      }
    };
  }
);

export default Report7Applicant;
